import { useRef, useMemo, useCallback } from 'react';
import { createImperativePromise } from 'awesome-imperative-promise';
import debounce from 'debounce-promise';
function useDebounce(asyncFunction, wait) {
  const cancelPrevious = useRef(null);
  const cancelFunction = useCallback(() => {
    if (cancelPrevious.current) {
      cancelPrevious.current();
    }
  }, []);
  const debounced = useMemo(() => debounce(asyncFunction, wait), [asyncFunction, wait]);
  const debouncedFunction = useCallback((...args) => {
    cancelFunction();
    const {
      promise,
      cancel
    } = createImperativePromise(debounced(...args));
    cancelPrevious.current = cancel;
    return promise;
  }, [cancelFunction, debounced]);
  return [debouncedFunction, cancelFunction];
}
export default useDebounce;